import { useContext } from 'react'

import { InitDataContext } from '../context'

export function useInitData() {
  return useContext(InitDataContext)
}
